import { Injectable } from '@angular/core';
import {
  ApplicationSettingsGQL,
  LotAiTranslationCreateGQL,
  LotAiTranslationCreateInput,
  LotTranslateRequestCreateGQL,
  LotTranslateRequestCreateInput,
} from '../../../graphql/service/graphql-auto-main-service';
import { MutationHandlingServiceV2, QueryHandlingService } from '@akebono/core';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

@Injectable()
export class LotTranslationService {
  constructor(
    private mhs: MutationHandlingServiceV2,
    private qhs: QueryHandlingService,
    private lotTranslateRequestCreateGQL: LotTranslateRequestCreateGQL,
    private lotAiTranslationCreateGQL: LotAiTranslationCreateGQL,
    private applicationSettingsGQL: ApplicationSettingsGQL,
  ) {}

  getAiEnabled(): Observable<boolean> {
    return this.qhs.fetch(this.applicationSettingsGQL, {}, 'network-only').data.pipe(
      map((data) => data?.applicationSettings?.aiTranslationGenerationEnabled ?? false),
      catchError(() => of(false)),
    );
  }

  requestTranslate(input: LotTranslateRequestCreateInput): Observable<boolean> {
    return this.mhs.mutate(
      this.lotTranslateRequestCreateGQL,
      {
        input,
      },
      { refetch: true },
    ).loading;
  }

  requestAiTranslation(input: LotAiTranslationCreateInput): Observable<boolean> {
    return this.mhs.mutate(this.lotAiTranslationCreateGQL, {
      input,
    }).loading;
  }
}
